// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"630":"bc458bdb","779":"3302d1d1"}[chunkId] + ".chunk.css";
};